// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__xAP3q","messages":"Chat_messages__2e3hS","dateDivider":"Chat_dateDivider__HYcFO"};